<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> {{$t('pages.monitorEqu.breadcrumb')}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div>
                <div class="handle-headleft">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAdd">{{$t('pages.monitorEqu.add')}}</el-button>
                    <el-button type="primary" icon="el-icon-s-tools" @click="handleBf('1')">{{$t('pages.monitorEqu.deployAll')}}</el-button>
                    <el-button type="primary" icon="el-icon-setting" @click="handleBf('2')">{{$t('pages.monitorEqu.undeployAll')}}</el-button>
                    <!-- <el-button type="danger" icon="el-icon-delete" @click="delAllSelection">删除 </el-button> -->
                </div>
                <div class="handle-headright">
                    <el-input v-model="query.Field1" @blur="getData()" class="handle-select mr10" :placeholder="$t('pages.monitorEqu.namePh')"></el-input>
                    <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.monitorEqu.search')}}</el-button>
                </div>
            </div>
            <el-table :data="monitors" border class="table" ref="multipleTable" :element-loading-text="$t('pages.monitorEqu.loading')" v-loading="loading" header-cell-class-name="table-header" @selection-change="handleSelectionChange" @row-dblclick="dbSelected">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column type="index" width="50" :label="$t('pages.monitorEqu.index')"></el-table-column>
                <el-table-column sortable prop="balanceName" :label="$t('pages.monitorEqu.scaleName')"></el-table-column>
                <el-table-column sortable prop="displayName" :label="$t('pages.monitorEqu.deviceName')"></el-table-column>
                <el-table-column prop="deviceIP" :label="$t('pages.monitorEqu.deviceIP')"></el-table-column>
                <el-table-column prop="devicePort" :label="$t('pages.monitorEqu.devicePort')"></el-table-column>
                <el-table-column :label="$t('pages.monitorEqu.status')" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.isDeploy === '布防成功' ? 'success' : 'danger'">{{ scope.row.isDeploy }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('pages.monitorEqu.enabled')">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.EnabledFt" @change="changeUse(scope.row)" />
                    </template>
                </el-table-column>
                <el-table-column prop="userName" :label="$t('pages.monitorEqu.userName')"></el-table-column>
                <el-table-column sortable prop="modifyDate" :label="$t('pages.monitorEqu.modifyTime')" width="140">
                    <template slot-scope="scope">{{ scope.row.modifyDate | formateData }}</template>
                </el-table-column>
                <el-table-column :label="$t('pages.monitorEqu.operation')" width="180" align="center">
                    <template slot-scope="scope">
                        <!-- <el-button type="text" icon="el-icon-tickets" @click="handleShow(scope.row.id, scope.row)">查看 </el-button> -->
                        <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row.id, scope.row)">{{$t('pages.monitorEqu.edit')}}</el-button>
                        <el-button type="text" icon="el-icon-delete" @click="handleDel(scope.row.id, scope.row)">{{$t('pages.monitorEqu.delete')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>
        <!-- 编辑弹出框 -->
        <el-dialog :title="headTitle" :visible.sync="editVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="monitor" :model="monitor" :rules="rules" label-width="100px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.monitorEqu.deviceName')" prop="displayName">
                            <el-input v-model="monitor.displayName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.monitorEqu.monitorTarget')" prop="balanceId">
                            <el-select v-model="monitor.balanceId" :placeholder="$t('pages.monitorEqu.selectPh')" class="size-full"  ref="selectBalance">
                                <el-option v-for="item in balanceArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.monitorEqu.deviceIP')" prop="deviceIP">
                            <el-input v-model="monitor.deviceIP"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.monitorEqu.devicePort')" prop="devicePort">
                            <el-input v-model="monitor.devicePort"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.monitorEqu.userName')" prop="userName">
                            <el-input v-model="monitor.userName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.monitorEqu.password')" prop="userPwd">
                            <el-input v-model="monitor.userPwd" class="size-full" show-password></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.monitorEqu.urlSuffix')" prop="urlSuffix">
                            <el-input v-model="monitor.urlSuffix"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.monitorEqu.use')" prop="enabled">
                            <el-switch v-model="monitor.enabled"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">{{$t('pages.monitorEqu.cancel')}}</el-button>
                <el-button type="primary" @click="saveEdit('monitor')">{{$t('pages.monitorEqu.confirm')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { SortField, toTree } from '../../utils/helper';
export default {
    name: 'monitor',
    data: function () {
        return {
            headTitle: '',
            isadd: false,
            monitor: {},
            editVisible: false,
            monitors: [],
            pageCount: 1,
            multipleSelection: [],
            balanceArr: [],
            delList: [],
            loading: false,
            query: {
                Field1: '',
                Field2: '',
                PageIndex: 1,
                PageSize: 15
            },
            rules: {
                displayName: [
                    {
                        required: true,
                        message: this.$t('pages.monitorEqu.valid.deviceNameRequired'),
                        trigger: 'blur'
                    },
                    {
                        min: 2,
                        max: 15,
                        message: this.$t('pages.monitorEqu.valid.deviceNameLength'),
                        trigger: 'blur'
                    }
                ],
                deviceIP: [
                    {
                        required: true,
                        message: this.$t('pages.monitorEqu.valid.deviceIpRequired'),
                        trigger: 'blur'
                    }
                ],
                devicePort: [
                    {
                        required: true,
                        message: this.$t('pages.monitorEqu.valid.devicePortRequired'),
                        trigger: 'blur'
                    }
                ],
                userName: [
                    {
                        required: true,
                        message: this.$t('pages.monitorEqu.valid.userNameRequired'),
                        trigger: 'blur'
                    }
                ],
                userPwd: [
                    {
                        required: true,
                        message: this.$t('pages.monitorEqu.valid.passwordRequired'),
                        trigger: 'blur'
                    }
                ],
                balanceId: [
                    {
                        required: true,
                        message: this.$t('pages.monitorEqu.valid.balanceRequired'),
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    created() {
        this.getData();
    },
    methods: {
        saveEdit() {
            this.$refs['monitor'].validate((valid) => {
                if (valid) {
                    this.monitor.enabled = this.monitor.enabled ? '1' : '0';
                    this.monitor.balanceName = this.$refs.selectBalance.selectedLabel;
                    if (this.isadd) {
                        this.$zybhttp
                            .post('MonitorEqu/MonitorEquAdd', this.monitor)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.monitorEqu.addSuccess'));
                                    this.getData();
                                    this.editVisible = false;
                                    this.monitor = {};
                                } else {
                                    this.$notify.error(res.data.msg);
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.monitorEqu.addError')));
                    } else {
                        this.$zybhttp
                            .post('MonitorEqu/MonitorEquUpdate', this.monitor)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.monitorEqu.updateSuccess'));
                                    this.getData();
                                    this.editVisible = false;
                                } else {
                                    this.$notify.error(this.$t('pages.monitorEqu.updateFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.monitorEqu.updateError')));
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getData() {
            // this.loading=true;
            this.$zybhttp
                .post('MonitorEqu/GetList', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('Id', 'desc'));
                        newdata = newdata.map((x) => {
                            x.EnabledFt = x.enabled == '1';
                            return x;
                        }, []);
                        this.monitors = newdata;
                        this.pageCount = res.data.total || 0;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.monitorEqu.fetchError')));
        },
        getBalances() {
            this.$zybhttp
                .get('Balance/GetBalance', {
                    params: { balanceId: '' }
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.balanceArr = [{ id: 0, name: this.$t('pages.monitorEqu.selectPh') }].concat(d);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.monitorEqu.fetchError')));
        },
        changeUse(row) {
            row.enabled = row.EnabledFt ? '1' : '0';
            this.$zybhttp
                .post('MonitorEqu/MonitorEquUpdate', row)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('pages.monitorEqu.updateSuccess'));
                        this.getData();
                    } else {
                        this.$notify.error(this.$t('pages.monitorEqu.updateFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.monitorEqu.updateError')));
        },
        handleEdit(id, row) {
            this.getBalances();
            this.monitor = JSON.parse(JSON.stringify(row));
            this.monitor.id = id;
            this.editVisible = true;
            this.monitor.enabled = this.monitor.enabled == '1';
            this.isadd = false;
            this.headTitle = this.$t('pages.monitorEqu.editTitle');
        },
        handleBf(option) {
            this.$confirm(option == '1' ? this.$t('pages.monitorEqu.confirmDeploy') : this.$t('pages.monitorEqu.confirmUndeploy'), this.$t('pages.monitorEqu.tip'), {
                type: 'warning'
            })
                .then(() => {
                    this.$zybhttp
                        //.get('MonitorEqu/MonitorEquDel?ids=1')
                        .get('MonitorEqu/MonitorEquBFCF', {
                            params: { option: option }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(res.data.msg);
                                this.getData();
                            } else {
                                this.$notify.error(res.data.msg);
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('pages.monitorEqu.deleteError')));
                })
                .catch(() => {});
        },
        handleDel(id, row) {
            this.$confirm(this.$t('pages.monitorEqu.confirmDelete'), this.$t('pages.monitorEqu.tip'), {
                type: 'warning'
            })
                .then(() => {
                    this.$zybhttp
                        //.get('MonitorEqu/MonitorEquDel?ids=1')
                        .get('MonitorEqu/MonitorEquDel', {
                            params: { ids: id }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(this.$t('pages.monitorEqu.deleteSuccess', { name: row.displayName }));
                                this.getData();
                            } else {
                                this.$notify.error(this.$t('pages.monitorEqu.deleteFail'));
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('pages.monitorEqu.deleteError')));
                })
                .catch(() => {});
        },
        dbSelected(row) {
            this.getBalances();
            this.monitor = JSON.parse(JSON.stringify(row));
            this.monitor.id = row.id;
            this.editVisible = true;
            this.monitor.enabled = this.monitor.enabled == '1';
            this.isadd = false;
            this.headTitle = this.$t('pages.monitorEqu.editTitle');
            // console.log(row);
        },
        handleAdd() {
            this.getBalances();
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            this.monitor = {};
            this.isadd = true;
            this.monitor.createUserId = userinfo.loginId;
            this.monitor.modifyUserId = userinfo.loginId;
            // this.monitor.balanceId = 0;
            this.monitor.urlSuffix = ':554/h264/ch1/sub/av_stream';

            //this.monitor.isUse =true;
            this.editVisible = true;
            this.headTitle = this.$t('pages.monitorEqu.addTitle');
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            let strValue = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].displayName + ' ';
                strValue += this.multipleSelection[i].id + ',';
            }
            if (strValue.length == 0) {
                this.$notify.warning(this.$t('pages.monitorEqu.warn.selectToDelete'));
                return;
            }
            this.$confirm(this.$t('pages.monitorEqu.confirmDelete'), this.$t('pages.monitorEqu.tip'), {
                type: 'warning'
            })
                .then(() => {
                    this.$zybhttp
                        //.get('MonitorEqu/MonitorEquDel?ids=1')
                        .get('MonitorEqu/MonitorEquDel', {
                            params: { ids: strValue }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(this.$t('pages.monitorEqu.deleteBatchSuccess', { names: str }));
                                this.getData();
                            } else {
                                this.$notify.error(this.$t('pages.monitorEqu.deleteFail'));
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('pages.monitorEqu.deleteError')));
                    this.multipleSelection = [];
                })
                .catch(() => {});
        },
        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}
.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
</style>

<style>
/* 富文本框高度设置 */
.ql-container {
    min-height: 200px;
    height: 200px;
}
</style>
